/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import Tour from 'reactour';
import { Trans } from 'react-i18next';

import LayoutSimple from '../components/LayoutSimple.jsx';
import NavigatorFoto from '../components/NavigatorFoto.jsx';
import Map from '../components/Map.jsx';
import OptionMapSelectorFoto from '../components/OptionMapSelectorFoto.jsx';

import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {createTheme} from '@material-ui/core/styles';
import {ThemeProvider} from '@material-ui/styles';

import LocalStorage from '../service/LocalStorage';

import i18n from '../resources/i18n';
import {properties} from '../resources/properties.js';

declare var M;
const plugin = new M.plugin.Mapaalacarta({
  enabled: true, posterMode: true
});
const xylocator = new M.plugin.XYLocator();
const ignsearch = new M.plugin.IGNSearch({
  urlFind : properties.urlGeocoder+"/api/geocoder/findJsonp",
  urlCandidates : properties.urlGeocoder+"/api/geocoder/candidatesJsonp", 
  urlReverse : properties.urlGeocoder+"/api/geocoder/reverseGeocode",
  servicesToSearch: "g",
  maxResults: 30,
  noProcess:"expendeduria"
});
const fullviewmap = new M.plugin.FullViewMap({
  position: 'BL',
});
const scaleZoomPlugin = new M.plugin.ScaleZoom(plugin);
const insertPhotoPlugin = new M.plugin.InsertPhoto({
  position: 'BL',
});
const editionTools = new M.plugin.EditionTools({numberOfDrawFeatures: 0, precharged: properties.ROUTE_CATALOGUE_URLS, minScale: properties.MINSCALE});

const pluginList = [plugin, ignsearch, xylocator, scaleZoomPlugin, fullviewmap, insertPhotoPlugin];

const theme = createTheme({
  palette: { primary: { 500: properties.BUTTON_THEME_COLOR } },
  overrides: { MuiButton: { containedPrimary: { color: 'white' } } }
});
const themeTitle = createTheme({
  palette: { primary: { 500: properties.TITLE_THEME_COLOR } },
  overrides: { MuiDialogTitle: { root: { backgroundColor: properties.TITLE_THEME_COLOR, color: 'white' } } }
});

class Step1F extends Component {
  constructor(props) {
    super(props);
    this.state = {
      centerX: -417002.20780977904,
      centerY: 4931965.4853014955,
      isTourOpen: false,
      showModalWarningLegend: false
    };
    this.handleShowWarningLegend = this.handleShowWarningLegend.bind(this);
    this.handleCloseWarningLegend = this.handleCloseWarningLegend.bind(this);
    this.handleCloseWarningLegendContinue = this.handleCloseWarningLegendContinue.bind(this);
    window.showWarningLegend = this.handleShowWarningLegend;
    const {parentState} = this.props;
    parentState.isSimple = false;
    parentState.seleccionadoProductoSeries = 'Foto';
    //TestAdminUSER
    let testLogin = LocalStorage.get('login-cookie');// POSIBLEMENTE ES MEJOR MOVERLO FUERA DE AQUí con otro metodo de saber su estado antes de llegar aquí
    if(testLogin && testLogin.fecha > new Date().getTime()){
      this.props.parentState.specialMapGeneration = (testLogin.token === properties.TOKEN);
      this.props.parentState.author = 'CNIG';
    }else{
      LocalStorage.delete('login-cookie');
      this.props.parentState.specialMapGeneration = false;
      delete this.props.parentState.nipo;
      delete this.props.parentState.isbn;
      delete this.props.parentState.depositoLegal;
      delete this.props.parentState.codigoBarras;
      delete this.props.parentState.realCodigoBarras;
      delete this.props.parentState.specialFileName;
    }
    testLogin = null;
    //TestAdminUSER
    this.setStateGlobal(parentState);
  }

  closeTour = () => {
    this.setState({isTourOpen: false});
  }

  openTour = () => {
    this.setState({isTourOpen: true});
  }

  setStateGlobal = (state) => {
    const {setParentState} = this.props;
    setParentState(state);
  }

  setModal = (mapa, state) => {
    const {setModal} = this.props;
    setModal(mapa, state);
  }

  setStateGlobalStep = (state) => {
    const {setParentStateSteps} = this.props;
    setParentStateSteps(state);
  }

  setMapa = (map) => {
    let {parentState} = this.props;
    parentState.mapa = map;
    this.setStateGlobal(parentState);
  };

  convertScaleValueToScaleFactor(scaleValue) {
    var scaleFactor = 0;
    switch (scaleValue) {
      case '1:2.500':
        scaleFactor = 2.5;
        break;
      case '1:5.000':
        scaleFactor = 5;
        break;
      case '1:10.000':
        scaleFactor = 10;
        break;
      case '1:25.000':
        scaleFactor = 25;
        break;
      default:
        scaleFactor = 2.5;
    }

    return scaleFactor;
  }

  setScaleValue = (event) => {
    let {parentState} = this.props;
    parentState.scale = event;
    this.setStateGlobal(parentState);
    switch (event) {
      case '1:2.500':
        parentState.selectedRow = '2.5K';
        parentState.scaleCm = '25 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 2.5);
        parentState.previousScale = event;
        parentState.zoom = 15;
        break;
      case '1:5.000':
        parentState.selectedRow = '5K';
        parentState.scaleCm = '50 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 5);
        parentState.previousScale = event;
        parentState.zoom = 14;
        break;
      case '1:10.000':
        parentState.selectedRow = '10K';
        parentState.scaleCm = '100 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 10);
        parentState.previousScale = event;
        parentState.zoom = 13;
        break;
      default:
        parentState.selectedRow = '25K';
        parentState.scaleCm = '250 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 25);
        parentState.previousScale = event;
        parentState.zoom = 12;
        break;
    }

    this.setStateGlobal(parentState);
    if(window.mapJs.getZoom()<parentState.zoom){
      plugin.setMapCenterZoom(parentState.mapa, parentState.zoom);
    }

    // actualizar escala del plugin insertPhoto
    const scaleDenominator = parseFloat(event.replace('1:', '').replace('.', ''));
    insertPhotoPlugin.updateScale(scaleDenominator);

    return parentState.scale;
  }

  setOrientation = (event) => {
    let {parentState} = this.props;
    if (parentState.previousOrientation !== parentState.orientation) {
      // this.setState({orientation: event});
      plugin.rotate(event);
      plugin.setMapCenterZoom(parentState.mapa, parentState.zoom);
      parentState.orientation = event;
      this.setStateGlobal(parentState);

    }
    this.setStateGlobal(parentState);
  }

  handleShowWarningLegend() {
    this.props.parentState.numberId = editionTools.getNumberOfIdFeature();//update del numberId
    this.setState({showModalWarningLegend: true});
  }
  handleCloseWarningLegend() {
    this.setState({showModalWarningLegend: false});
    const drawLegend = document.querySelector('div.m-control.m-addlegend-container');
    if (drawLegend.classList.contains('activated')) {
      drawLegend.children[0].click();
    }
  }
  handleCloseWarningLegendContinue(){
    this.setState({showModalWarningLegend: false});
    editionTools.toggleLegendMenu();
  }
  componentWillUnmount(){
    window.showWarningLegend = null;
  }

  render() {
    const {parentState} = this.props;

    editionTools.setNumberOfIdFeature(parentState.numberId);
    scaleZoomPlugin.setState(parentState);
    scaleZoomPlugin.setCallbackState(this.setStateGlobal);
    const {centerX, centerY, isTourOpen} = this.state;

    const steps = [
      {
        selector: '.first-step',
        content: i18n.t('tour.step1FirstStepPhoto'),
      },
      {
        selector: '.second-step',
        content: i18n.t('tour.step1SecondStepFoto'),
        style: {
          whiteSpace: "pre-line",
          padding: "24px 40px",
        },
      },
      {
        selector: '.third-step',
        content: i18n.t('tour.step1ThirdStep'),
      },
      {
        selector: '.fourth-step',
        content: i18n.t('tour.step1FourthStep'),
      },
      {
        selector: '.fifth-step',
        content: i18n.t('tour.step1FifthStep'),
      },
      {
        selector: '.search-panel',
        content: i18n.t('tour.step1SixthStep'),
      },
      {
        selector: '.m-xylocator',
        content: i18n.t('tour.step1SeventhStep'),
      },
      {
        selector: '.m-scalezoom',
        content: i18n.t('tour.step1TenthStep'),
      },
      {
        selector: '#container-button2',
        content: i18n.t('tour.step1EleventhStep'),
      },
      {
        selector: '.m-plugin-fullviewmap',
        content: i18n.t('tour.step1EighthStep'),
      },
      {
        selector: '#m-insertPhoto-btn',
        content: i18n.t('tour.step1TwelveStep'),
      },
      {
        selector: '.m-tools-editionTools',
        content: i18n.t('tour.step1NinthStep'),
      },
      {
        selector: '#m-button-drawFeature',
        content: i18n.t('tour.step1NinthPointTwoStep'),
      },
      {
        selector: '#m-button-drawFeature2',
        content: i18n.t('tour.step1NinthPointThreeStep'),
      },
      {
        selector: '#m-button-drawFeature3',
        content: i18n.t('tour.step1NinthPointFourStep'),
      },
      {
        selector: '#m-button-drawFeature5',
        content: i18n.t('tour.step1NinthPointFiveStep'),
      },
      {
        selector: '#m-button-addprecharged',
        content: i18n.t('tour.step1NinthPointNineStep'),
      },
      {
        selector: '#m-button-locallayers',
        content: i18n.t('tour.step1NinthPointOneStep'),
      },
      {
        selector: '#m-button-addlegend',
        content: i18n.t('tour.step1AddLegend'),
      },
      {
        selector: '#m-button-pickfeature',
        content: i18n.t('tour.step1NinthPointFiveTwoStep'),
      },
      {
        selector: '#m-button-moveFeature',
        content: i18n.t('tour.step1NinthPointSixStep'),
      },
      {
        selector: '#m-button-editFeature',
        content: i18n.t('tour.step1NinthPointSevenStep'),
      },
      {
        selector: '#m-button-deleteFeature',
        content: i18n.t('tour.step1NinthPointEightStep'),
      },
      {
        selector: '#m-button-downloadLayer',
        content: i18n.t('tour.step1NinthPointTenStep'),
      },
      {
        selector: '#m-button-undoFeature',
        content: i18n.t('tour.step1NinthPointElevenStep'),
      }
    ]

    //Left navigator
    const leftFirstDivClassName = 'wizard-1';
    const leftSecondDivClassName = 'circle bg-active';
    const leftTextSecondDivClassName = 'mc-design mc-2x';
    const leftLabelClassNameTittle = 'step-name active';
    const leftLabelTextTittle = i18n.t('step1.leftLabelTextTittle');
    const leftLabelClassNameDescription = 'step-description';
    const leftLabelDescription = i18n.t('step1.leftLabelDescription');
    const leftBarClassName = 'bar';

    //Center navigator
    const centerFirstDivClassName = 'wizard-2';
    const centerSecondDivClassName = 'circle';
    const centerTextSecondDivClassName = 'mc-map mc-2x';
    const centerLabelClassNameTittle = 'step-name';
    const centerLabelTextTittle = i18n.t('step1.centerLabelTextTittle');
    const centerLabelClassNameDescription = 'step-description';
    const centerLabelDescription = i18n.t('step1.centerLabelDescription');
    const rightBarClassName = 'bar';
    //Right navigator
    const rightFirstDivClassName = 'wizard-3';
    const rightSecondDivClassName = 'circle';
    const rightTextSecondDivClassName = 'mc-pin-check mc-2x';
    const rightLabelClassNameTittle = 'step-name';
    const rightLabelTextTittle = i18n.t('step1.rightLabelTextTittle');
    const rightLabelClassNameDescription = 'step-description';
    const rightLabelDescription = i18n.t('step1.rightLabelDescription');

    //StepBody
    const stepClassName = 'step1'
    const sectionClassName = 's1-left';
    const asideClassName = 's1-right';

    //Next and previous pages
    const nextPage = '/Step2';
    const previousPage = '/main';

    // classes
    const classPanelContent = 'panel-content';
    const classPanelButton = 'panel-button';

    return (<React.Fragment>
      <LayoutSimple setParentStateSteps={this.setStateGlobalStep} parentState={parentState} inforCoords={parentState.inforFeatureCoordinates[0]} label={null} activeRow={this.props.activeRow} nextPage={nextPage} previousPage={previousPage} isStep3={0}>
        <Dialog open={this.state.showModalWarningLegend} onClose={this.handleCloseWarningLegend} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle color="primary" id="alert-dialog-title">
            <Trans i18nKey="dialog.generateLegend">
              Generar leyenda
            </Trans>
            </DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <Trans i18nKey="dialog.generateLegendWarning">
              Se recomienda configurar la leyenda solo tras finalizar el añadido y estilado de todas las demás entidades del mapa.
            </Trans>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWarningLegendContinue}>
              <Trans i18nKey="dialog.continue">CONTINUAR</Trans>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWarningLegend}>
              <Trans i18nKey="dialog.cancel">CANCELAR</Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
        <NavigatorFoto leftFirstDivClassName={leftFirstDivClassName} leftSecondDivClassName={leftSecondDivClassName} leftTextSecondDivClassName={leftTextSecondDivClassName} leftLabelClassNameTittle={leftLabelClassNameTittle} leftLabelTextTittle={leftLabelTextTittle} leftLabelClassNameDescription={leftLabelClassNameDescription} leftLabelDescription={leftLabelDescription} centerFirstDivClassName={centerFirstDivClassName} centerSecondDivClassName={centerSecondDivClassName} centerTextSecondDivClassName={centerTextSecondDivClassName} centerLabelClassNameTittle={centerLabelClassNameTittle} centerLabelTextTittle={centerLabelTextTittle} centerLabelClassNameDescription={centerLabelClassNameDescription} centerLabelDescription={centerLabelDescription} rightFirstDivClassName={rightFirstDivClassName} rightSecondDivClassName={rightSecondDivClassName} rightTextSecondDivClassName={rightTextSecondDivClassName} rightLabelClassNameTittle={rightLabelClassNameTittle} rightLabelTextTittle={rightLabelTextTittle} rightLabelClassNameDescription={rightLabelClassNameDescription} rightLabelDescription={rightLabelDescription} leftBarClassName={leftBarClassName} rightBarClassName={rightBarClassName} parentState={parentState} setParentStateSteps={this.setStateGlobalStep}></NavigatorFoto>
        <Tour
        steps={steps}
        isOpen={isTourOpen}
        onRequestClose={this.closeTour} />
        <h1>
          <i className="mc-design"></i>
          <label>
          <Trans i18nKey="step1.mapDesign">
            Diseño del mapa
          </Trans>
          </label>
        </h1>
        <div className={stepClassName}>
          <section className={sectionClassName}>
            <div className="fifth-step">
              <Map setModal={this.setModal} setParentState={this.setStateGlobal} location={this.props.location} pluginEdition={editionTools} parentState={parentState} activeServices={parentState.activeServices} pluginList={pluginList} M={M} centerX={centerX} centerY={centerY} mapa={this.setMapa} isSimple={false} baseLayer='PNOA'></Map>
            </div>
            <br/>
            <a onClick={this.openTour}>
              <label id="download-tui-image" className="inputfile generalHelpButton">
                <Trans i18nKey="wizardPanel.help">Ayuda</Trans>
              </label>
            </a>
          </section>
          <OptionMapSelectorFoto setParentState={this.setStateGlobal} parentState={parentState} actionScale={this.setScaleValue} actionOrientation={this.setOrientation}  scaleValueChild={parentState.scale} activeRow={this.props.activeRow} asideClassName={asideClassName} classPanelButton={classPanelButton} classPanelContent={classPanelContent} pluginEdition={editionTools}/>
        </div>
      </LayoutSimple>
    </React.Fragment>);
  }
}

export default Step1F;
